import React from 'react';
import { Shield, Award } from 'lucide-react';
import { useLanguage } from '@/contexts/LanguageContext';
import { motion } from 'framer-motion';

const CertificationsSection: React.FC = () => {
  const { t } = useLanguage();

  const certifications = [
    { code: 'UNE-EN 12572', description: 'Rocódromos' },
    { code: 'UNE-EN 15567', description: 'Parques de aventura' },
    { code: 'UNE-EN 16869', description: 'Vías Ferrata' },
    { code: 'UNE-EN 1177', description: 'Suelos de seguridad' },
  ];

  return (
    <section className="py-16 md:py-24 bg-muted">
      <div className="container mx-auto px-4">
        <motion.div
          className="text-center mb-12"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-50px" }}
          transition={{ duration: 0.5, ease: "easeOut" }}
        >
          <div className="flex items-center justify-center gap-2 mb-4">
            <Shield className="h-8 w-8 text-primary" />
            <h2 className="text-3xl md:text-4xl font-bold text-foreground">
              {t('cert.title')}
            </h2>
          </div>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            {t('cert.subtitle')}
          </p>
        </motion.div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6 max-w-4xl mx-auto">
          {certifications.map((cert, index) => (
            <motion.div
              key={index}
              className="bg-background rounded-lg p-6 text-center shadow-sm hover:shadow-md transition-shadow"
              initial={{ opacity: 0, y: 30, scale: 0.9 }}
              whileInView={{ opacity: 1, y: 0, scale: 1 }}
              viewport={{ once: true, margin: "-30px" }}
              transition={{ duration: 0.4, delay: index * 0.1, ease: "easeOut" }}
              whileHover={{ scale: 1.05 }}
            >
              <Award className="h-8 w-8 text-primary mx-auto mb-3" />
              <p className="font-bold text-foreground text-lg">{cert.code}</p>
              <p className="text-sm text-muted-foreground">{cert.description}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CertificationsSection;
